export function calcPaddingTop() {
    if (window.innerHeight < 400 && window.innerWidth > 500) {
        return 30;
    }
    return window.innerHeight > 650 ? 80 : 70;
}
